import { useEffect, useState } from 'react'
import dashBoardApi from '../../../api/dashBoard'

export const useDataEventsSection = (groupId) => {
  const [dataEvents, setDataEvents] = useState({})
  const [loadingEvents, setLoadingEvents] = useState(false)

  const fetchDashboard = async () => {
    if (!groupId) return

    try {
      setLoadingEvents(true)
      const response = await dashBoardApi.getEventsSection({ groupId })
      setDataEvents(response?.data)
    } catch (error) {
      console.error('Failed to fetch dashboard data:', error)
    } finally {
      setLoadingEvents(false)
    }
  }

  useEffect(() => {
    fetchDashboard()
  }, [groupId])

  return {
    dataEvents,
    loadingEvents,
  }
}
